import React from 'react';
import style from './style.module.scss';
import { DateView } from '@/ui';
import notImagePoster from '../../../../public/not-image.png';
import { MediaPoster, NoImage } from '../../../../components';

interface MediaListProps {
  arr: any;
}

export const MediaList: React.FC<MediaListProps> = ({ arr }) => {
  return (
    <div className={style.list}>
      {arr.map((elem: any) => {
        const poster =
          elem?.imageUrl?.url !== undefined &&
          process.env.NEXT_PUBLIC_APP_UPLOAD_URL + elem?.imageUrl?.url;

        return (
          <div className={style.item} key={elem.id}>
            <div className={style.left}>
              <div className={style.date}>
                <DateView dateCreate={elem.createdAt} />
              </div>
              {elem.imageUrl?.url ? (
                <MediaPoster poster={poster} />
              ) : (
                <NoImage width={406} height={232} image={notImagePoster} />
              )}
            </div>
          </div>
        );
      })}
    </div>
  );
};
